<div class="progress-note">
    <img src="src/img/progress-timer.svg"/>
    <p>{{ l10nKeys.progressMessage | vtranslate }}</p> 
</div>
